var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVideoRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.64355,26.38965,58.75,32.27246V24a.7502.7502,0,0,0-.75-.75H10a.7502.7502,0,0,0-.75.75V56a.7502.7502,0,0,0,.75.75H58a.7502.7502,0,0,0,.75-.75V47.68213l10.8916,5.92676A.75025.75025,0,0,0,70.75,52.9502V27.0498a.75054.75054,0,0,0-1.10645-.66015ZM69.25,51.688,58.3584,45.76123a.75025.75025,0,0,0-1.1084.65869V55.25H10.75V24.75h46.5v8.77979a.75054.75054,0,0,0,1.10645.66015L69.25,28.30713Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50,27.25A2.75,2.75,0,1,0,52.75,30,2.7528,2.7528,0,0,0,50,27.25Zm0,4A1.25,1.25,0,1,1,51.25,30,1.25116,1.25116,0,0,1,50,31.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoRecording);
export default __webpack_public_path__ + "static/media/icon_video_recording.91c5c76948dce0395be5f9e67cb30130.svg";
export { ForwardRef as ReactComponent };